// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"e564793a","539":"687efbca","787":"a17bb5ed"}[chunkId] + ".chunk.js";
};